export const preventSQLPatternInString = (str: string | undefined | null) => {
  if (str === undefined) return undefined;
  if (str === null) return null;

  return str.replaceAll('-', '&qn;');
};
